import { computed, ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

export enum FeatureToggles {
  EXAMPLE_TOGGLE = 'exampleToggle', // example feature toggle, please don't remove
  SHOW_IS_NEW_BADGE = 'showIsNewBadge',
}

const DEFAULT_FEATURES_VALUE: Record<FeatureToggles, boolean> = {
  [FeatureToggles.EXAMPLE_TOGGLE]: false,
  [FeatureToggles.SHOW_IS_NEW_BADGE]: false,
};

const useFeatureToggle = (toggle: FeatureToggles): ComputedRef<boolean> => {
  const route = useRoute();

  return computed(() => {
    return route.query?.[toggle] === 'true' || DEFAULT_FEATURES_VALUE[toggle];
  });
};

export default useFeatureToggle;
